<form id="register-form" [formGroup]="formGroup" (ngSubmit)="createItem($event)" class="info-content-container">
    <div id="titleHeader" class="title-header flex-row">
        <span class="flex-1">{{ 'glossary.admin.createNewItem' | translate }}</span>
        <button class="icon-button icon-close" (click)="goToGlossary()"></button>
    </div>
    <div class="scroll-container">
        <div class="content">
            <div class="information-container">
                <div class="statistics-title statistics-title--full">{{ 'users.main.information' | translate }}</div>
                <div class="information-content">
                    <div class="flex-row">
                        <div class="flex-1 card-cell">
                            <sag-ui-input
                                formControlName="title"
                                [required]="true"
                                [label]="'glossary.item.title' | translate"
                            />
                        </div>
                        @if (isGermanEnabled) {
                            <div class="flex-1 card-cell">
                                <sag-ui-input
                                    formControlName="titleDe"
                                    [required]="true"
                                    [label]="'glossary.item.titleDe' | translate"
                                />
                            </div>
                        }
                    </div>
                    <div class="flex-row">
                        <div class="flex-1 card-cell">
                            <div class="label-input required">
                                <label>{{ 'glossary.item.description' | translate }}</label>
                                <app-editor id="description" formControlName="description" />
                            </div>
                        </div>
                        @if (isGermanEnabled) {
                            <div class="flex-1 card-cell">
                                <div class="label-input required">
                                    <label>{{ 'glossary.item.descriptionDe' | translate }}</label>
                                    <app-editor id="descriptionDe" formControlName="descriptionDe" />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
